module.exports = __webpack_public_path__ + "static/media/SCR-A-079.5b701342.mp3";